class Header{
    constructor(el) {
        this.scope = el;
        this.backLinks = el.querySelectorAll('[data-back-link]');
        this.subNavs = el.querySelectorAll('details');
        this.toggleMenuElements = el.querySelectorAll("[data-toggle-menu]");
        this.navIsOpen = false;
        this.navigatingBack = false;
        this.openSubNav = null;
        this.mobileNavOpen = false;
        this.handleEscKey = (event) => {
            if (event.key === 'Escape') {
                this.closeSubNav(event.target, true);
                document.removeEventListener('keydown', this.handleEscKey);
            }
        };
        this.handleEscNav = (event) => {
            if (!event.target.closest('[data-subNav]')) {
                this.closeSubNav(event.target);
                document.removeEventListener('keyup', this.handleEscNav);
                if(event.target.hasAttribute('data-primary-nav')){
                    
                }
            }
        };
        this.handleEscClick = (event) => {
            if (!event.target.closest('[data-subNav]')) {
                this.closeSubNav(this.openSubNav);
                document.removeEventListener('click', this.handleEscClick);
            }
        };
        this.bindEvents();
    }

    bindEvents(){
        this.toggleMenuElements.forEach(toggle => toggle.addEventListener('click', () => this.toggleMobileNav()));
        this.subNavs.forEach(subNav => {
            let closeBound = false;
             subNav.addEventListener('toggle', event => {
                 event.stopPropagation();
                if(subNav.open){
                    if(this.openSubNav && this.openSubNav !== subNav && this.openSubNav.open){
                        this.openSubNav.open = false;
                    }
                    this.openSubNav = subNav;
                    const closeLinks = subNav.querySelectorAll("[data-close]"); 
                    if(closeLinks.length > 0){
                        if(!closeBound){
                            closeLinks.forEach(closeLink => {
                                closeLink.addEventListener("click", event => {
                                    this.closeSubNav(subNav.querySelector('summary'));
                                    //subNav.querySelector('summary').focus();
                                })
                            })
                            closeBound = true;
                        }
                    }
                    if(subNav.querySelector("[data-back]")){
                        subNav.querySelector("[data-back]").focus();
                    }
                    setTimeout(()=>{
                        document.addEventListener('keydown', this.handleEscKey);
                        document.addEventListener('keyup', this.handleEscNav);
                        document.addEventListener('click', this.handleEscClick);
                    }, 600)
                }
            })
        })
    }
    
    toggleMobileNav(){
        if(this.mobileNavOpen){
            this.scope.classList.toggle('open');
            setTimeout(()=> this.scope.classList.toggle('opening'), 400);
            document.querySelector("html").classList.remove('overflow-hidden');
            this.mobileNavOpen = false;
        }else{
            this.scope.classList.toggle('opening');
            setTimeout(()=> this.scope.classList.toggle('open'), 60);
            document.querySelector("html").classList.add('overflow-hidden');
            this.mobileNavOpen = true;
        }
    }
    
    closeSubNav(target, refocus = false){
        if(this.openSubNav && this.openSubNav.querySelector("summary")){
            const openNav = this.openSubNav.querySelector("summary");
            if(this.openSubNav){
                openNav.click();
            }
            refocus && openNav.focus();
        }
        this.navIsOpen = false;
        this.openSubNav = null;
    }

}

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("header").forEach(el => new Header(el));
});

if ("navigation" in window && typeof window.navigation.addEventListener === "function") {
    window.navigation.addEventListener("navigate", () => {
        setTimeout(() => {
            document.querySelectorAll("header").forEach(el => {
                new Header(el);
            });
        }, 60);
    });
}